import { get } from './base';

export default {
  getFeatures: () => get(`${process.env.REACT_APP_API_URL}cms/v1/feature/plan-features`),
};
